import { render, staticRenderFns } from "./official-price.vue?vue&type=template&id=6a0876a0&scoped=true"
import script from "./official-price.vue?vue&type=script&lang=js"
export * from "./official-price.vue?vue&type=script&lang=js"
import style0 from "./official-price.vue?vue&type=style&index=0&id=6a0876a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0876a0",
  null
  
)

export default component.exports